export function initHoverFunctionality() {
    $('.dropdown-menu').css('margin-top', 0);
    $('a.dropdown-toggle').on('click', function (e) {
        // reset shown menue
        $('.dropdown').removeClass('show').attr('aria-expanded', 'false');
        $('.dropdown').find('.dropdown-menu').removeClass('show');
        $('.dropdown-close-button').removeClass('show');
        //show menue
        let dataTarget = $(this).attr('data-target');
        let objLi = $('li.' + dataTarget);
        let objDiv = $('div.' + dataTarget);
        objLi.addClass('show').attr('aria-expanded', 'true');
        objDiv.addClass('show');
        objDiv.find('.dropdown-close-button').addClass('show');
    });

    $('.dropdown-close-button').on('click', function () {
        $('.dropdown').removeClass('show').attr('aria-expanded', 'false');
        $('.dropdown').find('.dropdown-menu').removeClass('show');
        $(this).removeClass('show');
    });
}

export function createMenu(selector, additionalClass) {
    let $navContainer = $(selector);
    $navContainer.on('click', (() => {
        toggleMenu($navContainer, additionalClass);
        document.body.classList.toggle('body-mobile-menu-active');
    }));
}

export function toggleMenu($navContainer, additionalClass) {
    let $targetContainer = $($navContainer.data('target'));
    if ($targetContainer.hasClass(additionalClass)) {
        $targetContainer.removeClass(additionalClass);
    } else {
        $targetContainer.addClass(additionalClass);
    }
}

let getSiblings = function (e) {
    let siblings = [];
    if (!e.parentNode) {
        return siblings;
    }
    let sibling = e.parentNode.firstChild;
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
}

export function initMobileMenuFunctionality() {
    let menuFirstLayerButtons = document.querySelectorAll('.menu-first-layer-button');
    menuFirstLayerButtons.forEach((e) => {
        e.addEventListener('click', function () {
            e.classList.toggle('d-none');
            let menuFirstLayerButtonListElement = e.parentNode;

            let backToMainMenuButton = menuFirstLayerButtonListElement.querySelector('.to-main-menu');
            backToMainMenuButton.classList.toggle('d-none');

            let siblings = getSiblings(menuFirstLayerButtonListElement);
            siblings.forEach((f) => {
                f.classList.toggle('d-none');
            });
            let menuNextLayerChild = menuFirstLayerButtonListElement.querySelector('.dropdown-mobile-layer-2');
            menuNextLayerChild.classList.toggle('d-none');
        })
    });
    let menuBackToMainMenuButtons = document.querySelectorAll('.to-main-menu');
    menuBackToMainMenuButtons.forEach((e) => {
        e.addEventListener('click', function () {
            let menuBackToMainMenuButtonParent = e.parentNode;

            let menuFirstLayerButton = menuBackToMainMenuButtonParent.querySelector('.menu-first-layer-button');
            menuFirstLayerButton.classList.toggle('d-none');

            e.classList.toggle('d-none');

            let siblingsChangeBack = getSiblings(menuBackToMainMenuButtonParent);
            siblingsChangeBack.forEach((f) => {
                f.classList.toggle('d-none');
            });
            let menuSecondLayerChildChangeBack = menuBackToMainMenuButtonParent.querySelector('.dropdown-mobile-layer-2');
            menuSecondLayerChildChangeBack.classList.toggle('d-none');
        })
    });
    let menuSecondLayerButtons = document.querySelectorAll('.menu-second-layer-button');
    menuSecondLayerButtons.forEach((e) => {
        e.addEventListener('click', function () {
            e.classList.toggle('d-none');
            e.classList.toggle('clicked-second-layer-button');

            let menuSecondLayerButtonListElement = e.parentNode;
            let siblingsSecond = getSiblings(menuSecondLayerButtonListElement);
            siblingsSecond.forEach((f) => {
                f.classList.toggle('d-none');
            });
            let menuThirdLayerChild = menuSecondLayerButtonListElement.querySelector('.dropdown-mobile-layer-3');
            menuThirdLayerChild.classList.toggle('d-none');

            let menuSecondLayerButtonListElementParent = menuSecondLayerButtonListElement.parentNode;
            let menuSecondLayerButtonListElementParentParent = menuSecondLayerButtonListElementParent.parentNode;
            let backToMainMenuNextButton = menuSecondLayerButtonListElementParentParent.querySelector('.back-to-previous-menu-button');
            backToMainMenuNextButton.classList.toggle('d-none');

            let backToSecondMenuButton = menuSecondLayerButtonListElementParentParent.querySelector('.to-second-menu');
            backToSecondMenuButton.classList.toggle('d-none');

            let menuSecondLayerButtonListElementCategoryButton = menuSecondLayerButtonListElement.querySelector('.clicked-second-layer-button');
            let menuSecondLayerButtonListElementCategoryParent = menuSecondLayerButtonListElementCategoryButton.parentNode;
            let menuSecondLayerButtonListElementCategory = menuSecondLayerButtonListElementCategoryParent.querySelector('.second-level-main-category');
            menuSecondLayerButtonListElementCategory.classList.toggle('d-none');
        })
    });
    let menuBackToSecondMenuButtons = document.querySelectorAll('.to-second-menu');
    menuBackToSecondMenuButtons.forEach((e) => {
        e.addEventListener('click', function () {
            let menuBackToSecondMenuButtonParent = e.parentNode;

            e.classList.toggle('d-none');

            let menuBackToMainMenuButton = menuBackToSecondMenuButtonParent.querySelector('.to-main-menu');
            menuBackToMainMenuButton.classList.toggle('d-none');

            let menuSecondLayerButtonListElementCategoryButtonChangeBack = menuBackToSecondMenuButtonParent.querySelector('.clicked-second-layer-button');

            let menuSecondLayerButtonListElementCategoryParentChangeBackParent = menuSecondLayerButtonListElementCategoryButtonChangeBack.parentNode;
            let menuSecondLayerButtonListElementCategoryChangeBack = menuSecondLayerButtonListElementCategoryParentChangeBackParent.querySelector('.second-level-main-category');
            menuSecondLayerButtonListElementCategoryChangeBack.classList.toggle('d-none');
            let menuSecondLayerButtonListElementCategoryChangeBackParent = menuSecondLayerButtonListElementCategoryChangeBack.parentNode;
            let siblingsSecondChangeBack = getSiblings(menuSecondLayerButtonListElementCategoryChangeBackParent);
            siblingsSecondChangeBack.forEach((f) => {
                f.classList.toggle('d-none');
            });

            let menuSecondLayerButtonListElementCategoryParentChangeBackLayer = menuSecondLayerButtonListElementCategoryParentChangeBackParent.querySelector('.dropdown-mobile-layer-3');
            menuSecondLayerButtonListElementCategoryParentChangeBackLayer.classList.toggle('d-none');

            menuSecondLayerButtonListElementCategoryButtonChangeBack.classList.toggle('d-none');
            menuSecondLayerButtonListElementCategoryButtonChangeBack.classList.toggle('clicked-second-layer-button');
        })
    });
}
